import * as THREE from 'three';
import { useRef, useReducer, useMemo, Suspense } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { useGLTF, Environment, Lightformer, MeshTransmissionMaterial } from '@react-three/drei';
import { CuboidCollider, BallCollider, Physics, RigidBody } from '@react-three/rapier';
import { EffectComposer, N8AO } from '@react-three/postprocessing';
import { easing } from 'maath';
import styles from './heroSec.module.css';
import { bannerVideo, bannerVideo1, bannerVideoImg } from '../../../assets';

// Accent colors for connectors
// const ACCENTS = ['#ffffff', '#ffffff', '#ffffff', '#ffffff'];

// Connector properties generator
// const createConnectors = (accentIndex) => [
//     { color: '#ffffff', roughness: 0.75 },
//     { color: '#ffffff', roughness: 0.75 },
//     { color: '#ffffff', roughness: 0.75 },
//     { color: '#ffffff', roughness: 0.75 },
//     { color: '#ffffff', roughness: 0.75 },
//     { color: '#ffffff', roughness: 0.75 },
//     { color: '#ffffff', roughness: 0.75 },
//     { color: '#ffffff', roughness: 0.75 },
//     { color: ACCENTS[accentIndex], roughness: 0.1, accent: true },
//     { color: ACCENTS[accentIndex], roughness: 0.1, accent: true },
//     { color: ACCENTS[accentIndex], roughness: 0.1, accent: true },
// ];

const HeroSec = () => (
    <div className={styles.heroSec_inner}>
        <div className={styles.heroSec_headerP}>
            <video loop muted autoPlay playsInline poster={bannerVideoImg}
                onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }
                }
            > <source src={bannerVideo1}
                type="video/mp4" /> Your browser does not support the video tag. </video> <img src={bannerVideoImg}
                    alt="Fallback" style={{ display: 'none', width: '100%', height: 'auto' }
                    }
            />
            {/* <Scene /> */}
        </div>
    </div>
);

export default HeroSec;

// function Scene(props) {
//     const [accent, click] = useReducer((state) => ++state % ACCENTS.length, 0)
//     const connectors = useMemo(() => createConnectors(accent), [accent])
//     return (
//         <Canvas onClick={click} dpr={[1, 1.5]} gl={{ antialias: false }} camera={{ position: [0, 0, 15], fov: 17.5, near: 1, far: 20 }} {...props}>
//             <color attach="background" args={['#000']} />
//             <ambientLight intensity={2} />
//             <spotLight position={[10, 10, 10]} angle={0.15} penumbra={1} intensity={1} />
//             <Physics gravity={[0, 0, 0]}>
//                 <Pointer />
//                 {connectors.map((props, i) => <Connector key={i} {...props} />) /* prettier-ignore */}
//                 <Connector position={[10, 10, 5]}>
//                     <Model>
//                         <MeshTransmissionMaterial transmission={0} clearcoat={1} thickness={0.1} anisotropicBlur={0.1} chromaticAberration={0.1} samples={6} resolution={512} />

//                     </Model>
//                 </Connector>
//             </Physics>
//             <EffectComposer disableNormalPass multisampling={8}>
//                 <N8AO distanceFalloff={1} aoRadius={1} intensity={4} />
//             </EffectComposer>
//             <Environment resolution={256}>
//                 <group rotation={[-Math.PI / 3, 0, 1]}>
//                     <Lightformer form="circle" intensity={1} rotation-x={Math.PI / 2} position={[0, 5, -9]} scale={2} />
//                     <Lightformer form="circle" intensity={1} rotation-y={Math.PI / 2} position={[-5, 1, -1]} scale={2} />
//                     <Lightformer form="circle" intensity={1} rotation-y={Math.PI / 2} position={[-5, -1, -1]} scale={2} />
//                     <Lightformer form="circle" intensity={1} rotation-y={-Math.PI / 2} position={[10, 1, 0]} scale={8} />
//                 </group>
//             </Environment>
//         </Canvas >
//     )
// }


// function Connector({ position, children, vec = new THREE.Vector3(), scale, r = THREE.MathUtils.randFloatSpread, accent, ...props }) {
//     const api = useRef()
//     const pos = useMemo(() => position || [r(10), r(10), r(10)], [])
//     useFrame((state, delta) => {
//         delta = Math.min(0.1, delta)
//         api.current?.applyImpulse(vec.copy(api.current.translation()).negate().multiplyScalar(0.2))
//     })
//     return (
//         <RigidBody linearDamping={4} angularDamping={1} friction={0.1} position={pos} ref={api} colliders={false}>
//             <CuboidCollider args={[0.38, 1.27, 0.38]} />
//             <CuboidCollider args={[1.27, 0.38, 0.38]} />
//             <CuboidCollider args={[0.38, 0.38, 1.27]} />
//             {children ? children : <Model {...props} />}
//             {accent && <pointLight intensity={4} distance={2.5} color={props.color} />}
//         </RigidBody>
//     )
// }


// function Pointer({ vec = new THREE.Vector3() }) {
//     const ref = useRef()
//     useFrame(({ mouse, viewport }) => {
//         ref.current?.setNextKinematicTranslation(vec.set((mouse.x * viewport.width) / 2, (mouse.y * viewport.height) / 2, 0))
//     })
//     return (
//         <RigidBody position={[0, 0, 0]} type="kinematicPosition" colliders={false} ref={ref}>
//             <BallCollider args={[1]} />
//         </RigidBody>
//     )
// }

// function Model({ children, color = '#ffffff', roughness = 0, ...props }) {
//     const ref = useRef()
//     const { nodes, materials } = useGLTF('/BlueBallonLogo.glb')
//     console.log("node", nodes)
//     useFrame((state, delta) => {
//         easing.dampC(ref.current.material.color, color, 0.2, delta)
//     })
//     return (
//         <mesh ref={ref} scale={6} geometry={nodes.Plane002.geometry}>
//             {/* <meshStandardMaterial metalness={0.2} roughness={roughness}  /> */}
//             <meshStandardMaterial color={color} roughness={roughness} />
//             {children}
//         </mesh>
//     )
// }
